import React, { useState, Fragment } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../../../Icon';
import { DAY_OF_WEEK, getKeyByValue, getWorkingHoursByDay } from '../../utils';
import styles from './index.styl';

export function WorkingHoursView({
  formatMessage,
  currentWorkingHours,
  schedule,
}) {
  const [isFullMode, setFullMode] = useState(false);
  const closedTitle = formatMessage({ id: 'googleMaps.closed' });

  const { sunday } = schedule;
  const sundayEntity = getWorkingHoursByDay(
    sunday,
    getKeyByValue(DAY_OF_WEEK, 'Sun'),
    closedTitle,
  );
  const safeSchedule = Object.entries(schedule);

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {formatMessage({ id: 'googleMaps.workingHours' })}
      </div>
      <div className={styles.content}>
        {!isFullMode && (
          <div className={styles.row} id={currentWorkingHours.currentDay}>
            <div className={styles.dayOfWeek}>
              {currentWorkingHours.currentDay}
            </div>
            <div className={styles.workingHours}>
              {currentWorkingHours.workingHours}
            </div>
            <Icon
              size={16}
              name="down"
              className={styles.toggleStateView}
              onClick={() => setFullMode(true)}
            />
          </div>
        )}
        {isFullMode && (
          <Fragment>
            <div className={styles.row} id={sundayEntity.day}>
              <div className={styles.dayOfWeek}>{sundayEntity.day}</div>
              <div className={styles.workingHours}>
                {sundayEntity.workingHours}
              </div>
              <Icon
                size={16}
                name="up"
                className={styles.toggleStateView}
                onClick={() => setFullMode(false)}
              />
            </div>
            {safeSchedule.map(([name, value]) => {
              if (name === getKeyByValue(DAY_OF_WEEK, 'Sun')) return;
              const entity = getWorkingHoursByDay(value, name, closedTitle);
              return (
                <div className={styles.row} id={name}>
                  <div
                    className={cn(styles.dayOfWeek, {
                      [styles.currentDay]: entity.isCurrentDay,
                    })}
                  >
                    {entity.day}
                  </div>
                  <div
                    className={cn(styles.workingHours, {
                      [styles.currentDay]: entity.isCurrentDay,
                    })}
                  >
                    {entity.workingHours}
                  </div>
                </div>
              );
            })}
          </Fragment>
        )}
      </div>
    </div>
  );
}

WorkingHoursView.propTypes = {
  formatMessage: PropTypes.func,
  schedule: PropTypes.object,
  currentWorkingHours: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/LocationDetailsPopUp/WorkingHoursView/index.jsx